// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__JEo_Y","choiceBoxes":"toolbarselects_choiceBoxes__11zDl","simpleField":"toolbarselects_simpleField__Es2oP"};